module.exports = __webpack_public_path__ + "static/img/model2-9.85e516be.jpg";